import React, { useState, useEffect } from "react";
import './pages.css'
import './home.css'
import { OTSLogoBanner } from "../Templates";
import { PageIntro } from '../Templates'
import { EventView } from '../EventTemplate'
import { get_future_events_with_filters } from '../../services/events_service'


const EventHighlight = ({ otsevent }) => {
    return (
        <section className="highlighted-event-container">
            <h3 className="event">Event Highlight: {otsevent.summary}</h3>
            <EventView otsevent={otsevent} />
        </section>
    )
}



const Home = () => {

    const [highlightedEvent, setHighlightedEvent] = useState({});
    const [showHighlightedEvent, setShowHighlightedEvent] = useState(true);

    async function fetchHighlightedEvent() {
        const highlighted_events = await get_future_events_with_filters({ is_published: true, is_highlighted: true })
        if (highlighted_events.data.length === 0) {
            setHighlightedEvent({})
        } else {
            setHighlightedEvent(highlighted_events.data[0])
        }
    }

    useEffect(() => {
        fetchHighlightedEvent()
        // console.log('highlightedEvent: ' + JSON.stringify(highlightedEvent))
    }, [])

    return (
        <React.Fragment>
            <h1>Olive Tree Solidarity</h1>
            <OTSLogoBanner />
            <PageIntro>OTS is a grassroots organization that emerged in Provo, UT from a desire to stand in solidarity with Palestine. We focus on organizing locally and collectively in Utah County. Read our <a href="https://docs.google.com/document/d/1huDSWh9SVkog7iAEs2sWm4KT4rwfX_XIAGoGLuu0BeY/edit?usp=drivesdk">Points of Unity</a> for the core purpose of our work.</PageIntro>
            <p id="homepage-subtitle" className="text_container">We are stronger together! We’re looking forward to working with you.</p>

            <section>
                <p className="text_container">Additionally this website acts as a public reference for the community to learn about our past and current work and to get involved in the fight for a free Palestine locally either by learning, participating or joining us.  We are stronger together! </p>
                <br />
                <p className="text_container">As an organization we have decided to self fund any events and projects and ask you to instead redirect any donations to <a href="https://gazasoupkitchen.com">Gaza Soup Kitchen</a>.</p>
                <div id="landingpage-links-container" className="content-box">
                </div>
            </section>

            {(showHighlightedEvent && Object.keys(highlightedEvent).length !== 0) && (<section className="highlighted-event"><EventHighlight otsevent={highlightedEvent} /></section>)}
        </React.Fragment>
    )
}

export default Home;